import React from 'react';
import { FieldRenderProps } from 'react-final-form';

import { AmountControl, IProps as AmountControlProps } from '../ui/AmountControl';

export const FieldAmountControl: React.FC<FieldRenderProps<number | undefined> & AmountControlProps> = ({
    input,
    meta,
    ...props
}) => <AmountControl {...input} {...props} error={meta.touched && meta.error && String(meta.error)} />;
